// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slurry-output-summary-grid {
	width: 100%;
	margin-top: 8px;
}

.slurry-output-summary-grid th,
.slurry-output-summary-grid td {
	padding: 6px 8px;
	vertical-align: middle;
}

.slurry-output-summary-grid th {
	white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/slurry-details/popups/slurry-test-output-summary/slurry-test-output-summary.component.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":[".slurry-output-summary-grid {\n\twidth: 100%;\n\tmargin-top: 8px;\n}\n\n.slurry-output-summary-grid th,\n.slurry-output-summary-grid td {\n\tpadding: 6px 8px;\n\tvertical-align: middle;\n}\n\n.slurry-output-summary-grid th {\n\twhite-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
